const THEMES = {
    ESCURO: 'ESCURO',
    CIGAM: 'CIGAM',
};

export { THEMES };
